<template>
  <button @click="open" class="btn btn-sm btn-primary mr-1 mb-1">
    <font-awesome-icon icon="mobile"/>&nbsp;{{ $t('buyNewMonthlyUserPackage') }}
    <b-modal v-model="showForm" no-close-on-backdrop no-enforce-focus :title="$t('buyNewMonthlyUserPackage')">
      <client-select attribute="client" :errors="formErrors" :model="formModel" :label="$t('client')"></client-select>
      <template v-if="formModel.client">
        <p><span>{{$t('creditBalance')}}</span>: <b-spinner v-if="clientLoading" small></b-spinner><b v-else>{{creditBalance | numFormat}}</b></p>
        <p><span>{{$t('creditLimit')}}</span>: <b-spinner v-if="clientLoading" small></b-spinner><b v-else>{{creditLimit | numFormat}}</b></p>
      </template>
      <form-input :model="formModel" :errors="formErrors" :label="$t('numberOfPackage')"
                  attribute="limit"></form-input>
      <time-picker :model="formModel" :errors="formErrors" :label="$t('fromDate')" attribute="fromDate" class="mr-2 mb-3"></time-picker>
      <time-picker :model="formModel" :errors="formErrors" :label="$t('endMonth')" attribute="endMonth" class="mr-2 mb-3"
                   unit="month"></time-picker>
      <form-input :model="formModel" attribute="note" :errors="formErrors" :label="$t('note')"></form-input>
      <hr>
      <p class="text-right"><b>{{ $t('numberOfPackage') }}</b>: <span class="text-success">{{ formModel.limit }}</span></p>
      <p class="text-right"><b>{{ $t('numberOfMonth') }}</b>: <span class="text-success">{{ numberOfMonth }}</span></p>
      <p class="text-right"><b>{{ $t('packagePricePerMonth') }}</b>: <span class="text-success">{{ $store.state.user.planFee | numFormat }}</span></p>
      <p class="text-right"><b>{{ $t('total') }}</b>: <span class="text-danger">{{ total | numFormat }}</span></p>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button class="btn btn-primary float-right" @click="buy"
                :disabled="!formModel.client || !formModel.fromDate || !formModel.endMonth || !numberOfMonth || !total || total > creditBalance - creditLimit || !['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)">
          {{ $t('buy') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>
import ClientSelect from "../../../components/ClientSelect";
import TimePicker from "../../../components/TimePicker";
import moment from 'moment';

export default {
  props: ['client'],
  components: {TimePicker, ClientSelect},
  data() {
    return {
      showForm: false,
      formModel: {
        client: this.client ? this.client : null,
        limit: 0,
        fromDate: moment(Date.now()).startOf('day'),
        endMonth: moment(Date.now()).endOf('month'),
      },
      formErrors: [],
      total: 0,
      numberOfMonth: 0,
      creditBalance: 0,
      creditLimit: 0,
      oldClient: null,
      clientLoading: false,
    }
  },
  methods: {
    buy() {
      let loader = this.$loading.show();
      this.$service({
        url: '/client-package/monthly-user/new',
        method: 'post',
        data: this.formModel
      }).then(response => {
        this.showForm = false;
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('buyPackageSuccess'),
            icon: 'success'
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('buyPackageFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          if (Array.isArray(error.response.data)) this.formErrors = error.response.data;
        }
      }).finally(() => {
        this.$bus.$emit('clientPackage');
        this.$bus.$emit('loadClient');
        loader.hide();
      });
    },
    async open() {
      this.formModel = {
        client: this.client ? this.client : null,
        limit: 0,
        fromDate: Date.now(),
        endMonth: Date.now(),
      };
      this.total = 0;
      this.numberOfMonth = 0;
      this.showForm = true
    },
  },
  watch: {
    "formModel": {
      handler(val) {
        if (val.fromDate && val.endMonth) {
          let start = moment(val.fromDate).startOf('month');
          let end = moment(val.endMonth).endOf('month') + 1;
          let monthCount = moment(end).diff(moment(start), 'month', true);
          if (moment(val.fromDate).date() >= 15) {
            monthCount -= 0.5;
          }
          this.numberOfMonth = monthCount;
          this.total = this.numberOfMonth * this.formModel.limit * this.$store.state.user.planFee;
        } else {
          this.numberOfMonth = 0;
          this.total = 0
        }
        if (val.client) {
          if (val.client !== this.oldClient) {
            this.clientLoading = true
            this.$bgService.get('/client/'+ val.client).then(response => {
              this.creditBalance = response.data.creditBalance;
              this.creditLimit = response.data.creditLimit;
              this.oldClient = val.client;
            }).finally(() => {
              this.clientLoading = false
            })
          }
        } else {
          this.oldClient = null;
          this.creditBalance = 0;
          this.creditLimit = 0;
        }
      }, deep: true
    }
  },
  i18n: {
    messages: {
      en: {
        buyNewMonthlyUserPackage: 'Buy new TGU',
        numberOfPackage: 'Number of package to buy',
        fromDate: 'From date',
        endMonth: 'Until month',
        numberOfMonth: 'Number of month',
        total: 'Total',
        buy: 'Buy',
        chooseExt: 'Choose ext',
        numberOfExt: 'Number of ext selected',
        buyPackageSuccess: 'Package bought successfully!',
        packagePricePerMonth: 'Package price per month'
      },
      vi: {
        buyNewMonthlyUserPackage: 'Mua mới TGU',
        numberOfPackage: 'Số gói muốn mua',
        fromDate: 'Tính từ ngày',
        endMonth: 'Đến hết tháng',
        numberOfMonth: 'Số tháng',
        total: 'Tổng cộng',
        buy: 'Mua',
        chooseExt: 'Chọn máy nhánh',
        numberOfExt: 'Số máy nhánh đã chọn',
        buyPackageSuccess: 'Mua cước thoại trọn gói thành công!',
        packagePricePerMonth: 'Đơn giá gói/ tháng',
      }
    }
  },
}
</script>